module.exports = __webpack_public_path__ + "static/media/dots.bfcc898c.png";